import { AsyncPipe, CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  inject,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormGroupDirective,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { EMPTY, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { SelectItem } from '../shared/select-item';

@Component({
  selector: 'core-autocomplete',
  imports: [
    CommonModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    AsyncPipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<mat-form-field
    appearance="fill"
    [formGroup]="formGroup"
    [ngClass]="selectClass"
  >
    @if (label) {
      <mat-label>{{ label }}</mat-label>
    }
    <input
      type="text"
      data-testid="autocompleteInput"
      matInput
      [formControlName]="controlName"
      [matAutocomplete]="auto"
    />
    <mat-autocomplete #auto="matAutocomplete">
      @for (option of filteredOptions$ | async; track option) {
        <mat-option [value]="option.value">
          {{ option.label }}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>`,
  styles: [``],
})
export class AutocompleteComponent implements OnInit {
  private readonly formGroupDirective = inject(FormGroupDirective);

  protected formGroup!: FormGroup;
  @Input({ required: true })
  public controlName!: string;
  protected get formControl() {
    return this.formGroup.get(this.controlName) as FormControl;
  }
  @Input({ required: true })
  public options: SelectItem[] | null = null;
  @Input()
  public label = '';
  @Input()
  public selectClass = '';
  protected filteredOptions$: Observable<SelectItem[]> = EMPTY;

  public ngOnInit() {
    this.formGroup = this.formGroupDirective.form;
    this.filteredOptions$ = this.formControl.valueChanges.pipe(
      startWith(''),
      map(value => this.applyFilter(value)),
    );
  }

  private applyFilter(value: string): SelectItem[] {
    if (!this.options) {
      return [];
    }
    const filterValue = value.toLowerCase();
    return this.options.filter(option =>
      option.label?.toLowerCase().includes(filterValue),
    );
  }
}
